import React, { SyntheticEvent, memo } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { ItemImage } from "types";

import { useDispatch } from "react-redux";
import { enableEditItemMode as enableEditItemModeAction } from "redux/slices/itemFormSlice";

export const ItemContent = memo(
  ({
    canEditItem,
    itemId,
    itemName,
    itemDescription,
    itemImages,
  }: {
    canEditItem: boolean;
    itemId: string;
    itemName: string;
    itemDescription: string;
    itemImages: ItemImage[];
  }) => {
    const dispatch = useDispatch();

    function enableEditItemMode(e: SyntheticEvent) {
      e.preventDefault();
      dispatch(enableEditItemModeAction(itemId));
    }

    return (
      <div>
        <div>
          {canEditItem ? (
            <a
              onClick={enableEditItemMode}
              href="#"
              className="link-dark text-decoration-none text-break"
              id={`edit-item-${itemId}`}
              aria-label="Edit item"
            >
              {itemName || <i className="bi-pencil-square"></i>}
            </a>
          ) : (
            itemName
          )}
        </div>
        {itemImages.length > 0 && (
          <div className="d-flex flex-wrap gap-2 mt-2">
            {itemImages.map((image) => (
              <a
                className="d-inline-block border"
                key={image.id || image.url}
                href={image.url}
                target="_blank"
                aria-label="Open image"
              >
                <img
                  src={image.url}
                  alt=""
                  style={{
                    maxWidth: "180px",
                    maxHeight: "180px",
                    objectFit: "contain",
                  }}
                />
              </a>
            ))}
          </div>
        )}
        <div>
          <small>
            <Markdown
              className="item-description-markdown"
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
            >
              {itemDescription}
            </Markdown>
          </small>
        </div>
      </div>
    );
  },
);
